// extracted by mini-css-extract-plugin
export default {"container":"BackgroundPicker_container__fGY2-","header":"BackgroundPicker_header__9A6au","trash":"BackgroundPicker_trash__Tz3YG","content":"BackgroundPicker_content__7edWf"};